// Import both app versions
import App from './App.svelte';
import StorefrontApp from './StorefrontApp.svelte';

// Check if URL matches storefront pattern, including optional preview text parameter
const path = window.location.pathname;
const storefrontMatch = path.match(/^\/storefront\/([^\/]+)(?:\/(.+))?/);

// Create the appropriate app instance
const app = new (storefrontMatch ? StorefrontApp : App)({
	target: document.body,
	props: storefrontMatch ? {
		storefront_hash: storefrontMatch[1],
		url_preview_text: storefrontMatch[2] ? decodeURIComponent(storefrontMatch[2]) : null
	} : {}
});

export default app;